import { Truck, MapPin } from "lucide-react";

export const Logo = ({ className = "", size = 34, light = false }) => (
  <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
    <div className="relative" style={{ width: size, height: size }}>
      <Truck size={size} strokeWidth={2.4} className="text-street-gold" />
      <MapPin size={size * 0.55} strokeWidth={2.6} className="text-coral-twist absolute -top-1 -right-1 fill-coral-twist/20" />
    </div>
    <span className="font-display font-extrabold leading-none" style={{ fontSize: size * 0.72 }}>
      <span className={light ? "text-white" : "text-urban-teal"}>Streat</span>
      <span className="text-street-gold">Eat</span>
    </span>
  </div>
);
